import { getClientStore, initImData, setI18nLocale } from '../state';
import { storage } from '../storage';

export function NextClientSideInit(
  store: ReturnType<typeof getClientStore>,
  { locale }: { locale?: string } = {}
) {
  try {
    const authDataFromServer = store.getState().user.authData;
    // 如果服务端有说明是首次匿名登陆，此时存下来即可，否则从本地读取
    if (!authDataFromServer.imAccountInfo?.account || !authDataFromServer.imAccountInfo?.password) {
      const localImAccountInfo = storage.auth.getLocalAuthData()?.imAccountInfo;
      const imToken = storage.easeMob.getToken();
      store.dispatch(
        initImData({
          imAccountInfo: localImAccountInfo,
          imToken,
        })
      );
    } else {
      storage.auth.saveAuthData(
        {
          imAccountInfo: authDataFromServer.imAccountInfo,
        },
        'server'
      );
      storage.easeMob.clearToken();
    }
    store.dispatch(setI18nLocale(locale || 'en'));
    localStorage.setItem('userId', JSON.stringify(authDataFromServer.userId));
  } catch {}
}
